"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewSession extends new_item_1.default {
    constructor(newSession) {
        super();
        this.created = newSession.created;
        this.completed = newSession.completed;
        this.cancelled = newSession.cancelled;
        this.subscriptionItems = newSession.subscriptionItems;
        this.physicalItems = newSession.physicalItems;
    }
}
exports.default = NewSession;
//# sourceMappingURL=new-session.js.map